// extracted by mini-css-extract-plugin
export default {"modal":"JYkI8aN6L83f_PuUclRW","icon":"xbuFXxJYxbfWio9Xu6Xh","title":"BlWE_AfPG7K3rHS0niBi","text":"a5ftLWtzkxKj1mMXV5S9","pulse":"fQtJu6feNXQahs7k1iJM"};